import * as React from "react";
import { Button } from "../ui/button";
import { BiPlus } from "react-icons/bi";
import { FaEdit } from "react-icons/fa";
import { toaster } from "../ui/toaster";
import { useEffect, useState } from "react";
import { useWebHelper } from "@viabl/echo-web-client-core";
import { FloatingLabelInput } from "../ui/floating-input-label";
import { DialogBody, DialogContent, DialogFooter, DialogRoot, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Dialog, Field, Fieldset, Separator, Text, useDisclosure, Portal, Select, createListCollection, ListCollection } from '@chakra-ui/react';
import { IBundle } from "../../pages/echoRoleBundles"
import { BundlesCombobox } from "./echoBundlesCombobox";

interface IProps {
    cb: Function,
    existingBundle: IBundle | null,
    intent: "edit" | "create", //lets us use this component for both editing and creating announcements, just need to change some of the text and the api call
}

export default function BundlesEditor(props: IProps) {
    const { onOpen, onClose } = useDisclosure();

    const [id, setId] = useState<string>()
    const [name, setName] = useState<string>()
    const [parentId, setParentId] = useState<string | undefined>(undefined)
    const [parentName, setParentName] = useState<string>()

    const [open, setOpen] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const webHelpers = useWebHelper();

    const validateForm = (): boolean => {
        const newErrors: { [key: string]: string } = {}

        // if (!id.trim()) {
        //     newErrors.id = "ID is required"
        // }
        if (!name || !name.trim()) {
            newErrors.name = "Name is required"
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleClickOpen = () => {

        onOpen();
        setOpen(true);
        setErrors({})

        if (props.intent === "edit" && props.existingBundle != null) {
            setId(props.existingBundle.id)
            setName(props.existingBundle.name)
            setParentId(props.existingBundle.parent_id)
            setParentName(props.existingBundle.parent_name)
        }
        else {
            // setId("")
            setName("")
            setParentId(undefined)
            setParentName("")
        }
    }

    const handleCreate = () => {
        if (!validateForm()) {
            toaster.create({
                title: "Validation Error",
                description: "Please fill in all required fields",
                type: "error",
            })
            return
        }

        let bundle = {
            name: name,
            parent_id: parentId
        }

        webHelpers.PutAsync("/api/rolebundle/", "auth", bundle).then((data: any) => {
            handleClose()
            props.cb()

            toaster.create({
                title: `Created Category`,
                type: "success",
            })
        })
    }

    const handleEdit = () => {
        if (!validateForm()) {
            toaster.create({
                title: "Validation Error",
                description: "Please fill in all required fields",
                type: "error",
            })
            return
        }

        let bundle = {
            name: name,
            parent_id: parentId
        }

        webHelpers.PostAsync("/api/rolebundle/" + id, "auth", bundle).then((data: any) => {
            handleClose()
            props.cb()

            toaster.create({
                title: `Updated Category`,
                type: "success",
            })
        })
    }

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    const handleNameChange = (e: React.FormEvent<HTMLInputElement>) => {
        setName(e.currentTarget.value);
    }

    useEffect(() => {
        console.log(parentId)
    }, [parentId])

    return (
        <>
            <DialogRoot
                open={open}
                aria-describedby="alert-dialog-slide-description"
                size={{ base: "md", "2xl": "sm" }}
            >
                <Dialog.Backdrop />
                <DialogTrigger>
                    <Button able size={"sm"} marginLeft={{ base: "10px", lg: "30px" }}
                        onClick={handleClickOpen}>
                        {props.intent === "create" ? <BiPlus /> : <FaEdit />}
                        {props.intent === "create" ? "Add Bundle" : "Edit"}
                    </Button>
                </DialogTrigger>
                <DialogContent marginTop={"0px"} marginBottom={"0px"}>
                    <DialogTitle>{props.intent === "create" ? "Add Bundle" : "Edit Bundle"}</DialogTitle>
                    <DialogBody padding={"10px"}>
                        <Fieldset.Root>
                            <Field.Root marginTop={"3px"}>
                                <Separator marginY={"10px"} />
                                <FloatingLabelInput label="Bundle Name" value={name} onChange={handleNameChange} />
                                {errors.categoryName && (
                                    <Text color="red.500" fontSize="sm" marginTop="4px">
                                        {errors.categoryName}
                                    </Text>
                                )}
                            </Field.Root>
                                <BundlesCombobox setParentIdState={setParentId} setParentNameState={setParentName} initialName={parentName} initialId={parentId}/>
                                {/* <Text>Bundle To be assigned debug: {parentName}: {parentId}</Text> */}
                            <Separator marginY={"10px"} />
                        </Fieldset.Root>
                    </DialogBody>
                    <DialogFooter>
                        <Button onClick={props.intent === "edit" ? handleEdit : handleCreate}
                            disabled={false}
                            bg={"AbleBlue"}
                            color={"white"}
                            _hover={{ color: "AbleYellow" }}>{props.intent === "edit" ? "Edit " : "Create Bundle"}</Button>
                        <DialogTrigger>
                            <Button onClick={handleClose} colorScheme="red" marginLeft={"10px"}>Cancel</Button>
                        </DialogTrigger>
                    </DialogFooter>
                </DialogContent>
            </DialogRoot>
        </>
    );
}